import {
    GET_ORG_KIOSKS_SUCCESS,
    GET_ORG_KIOSKS_FAILURE,
    GET_ORG_PANELS,
    GET_ORG_PANELS_SUCCESS,
    GET_ORG_PANELS_FAILURE
} from './types';

// Kiosks are loaded by the User saga calling `getOrgKiosks` directly — no trigger action.
export const getOrgKiosksSuccess = devices => {
    return {
        type: GET_ORG_KIOSKS_SUCCESS,
        payload: devices
    };
};
export const getOrgKiosksFailure = error => {
    return {
        type: GET_ORG_KIOSKS_FAILURE,
        payload: error
    };
};

export const getOrgPanels = org => {
    return {
        type: GET_ORG_PANELS,
        payload: org
    };
};

export const getOrgPanelsSuccess = panels => {
    return {
        type: GET_ORG_PANELS_SUCCESS,
        payload: panels
    };
};
export const getOrgPanelsFailure = error => {
    return {
        type: GET_ORG_PANELS_FAILURE,
        payload: error
    };
};
